import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Tab as SemanticTab } from 'semantic-ui-react';
import MobileNav from '../mobileNav';
import styles from './styles.scss';
const cx = classnames.bind(styles);
export const getMenuItemData = (menuItem, index) => {
    if (!menuItem)
        return {
            key: '',
            text: '',
            value: '',
        };
    if (typeof menuItem === 'object' && typeof menuItem.content === 'string') {
        return {
            key: menuItem.key,
            text: menuItem.content,
            value: menuItem.content,
        };
    }
    if (typeof menuItem === 'object' && React.isValidElement(menuItem.content)) {
        return {
            key: menuItem.key,
            text: menuItem.content,
            value: menuItem.value || menuItem.content,
        };
    }
    return {
        key: index,
        text: menuItem,
        value: menuItem,
    };
};
const getDropdownOptions = panes => {
    return panes.map(({ menuItem }, index) => getMenuItemData(menuItem, index));
};
const CustomCollapseWrapper = ({ renderer, index, label }) => (_jsx("div", { "data-elm-id": 'tabs_custom_collapse_wrapper', className: cx('custom-collapse-wrapper'), children: renderer({ index, label, defaultClassName: cx('custom-collapse') }) }));
CustomCollapseWrapper.propTypes = {
    renderer: PropTypes.func,
    index: PropTypes.number,
    label: PropTypes.string,
};
const Tab = ({ elmId = 'default', children, className, role = 'primary', collapsing = true, menu = { secondary: true, pointing: true }, panes, onTabChange, activeIndex, customCollapseRenderer, transparentMode, }) => {
    const dropDownOptions = getDropdownOptions(panes);
    const [activeTabIndex, setActiveTabIndex] = useState(activeIndex || 0);
    const [activeTabValue, setActiveTabValue] = useState(dropDownOptions[activeTabIndex]?.value);
    const defaultOnTabChange = (e, data) => {
        setActiveTabIndex(data.activeIndex);
        setActiveTabValue(dropDownOptions[data.activeIndex].value);
        if (onTabChange)
            onTabChange(e, data);
    };
    const finalActiveTabIndex = activeIndex || activeTabIndex;
    const defaultOnDropdownChange = (e, { value }) => {
        const tabs = panes;
        const activeIndex = tabs.findIndex(tab => value === getMenuItemData(tab.menuItem, null).value);
        defaultOnTabChange(null, {
            panes,
            activeIndex,
        });
    };
    const hasPanes = panes?.[0]?.render;
    return (_jsxs("div", { "data-elm-id": `tabs_container_${elmId}`, className: cx('tab-container', role, { collapsing, 'has-panes': hasPanes }, className), children: [customCollapseRenderer && (_jsx(CustomCollapseWrapper, { renderer: customCollapseRenderer, index: finalActiveTabIndex, label: getMenuItemData(panes?.[finalActiveTabIndex]?.menuItem, finalActiveTabIndex).text })), !customCollapseRenderer && (_jsx(MobileNav, { "data-elm-id": `tabs_dropdown_${elmId}`, options: dropDownOptions, value: activeTabValue, onChange: defaultOnDropdownChange })), _jsx(SemanticTab, { "data-elm-id": `tabs_${elmId}`, className: cx('tabs-and-panes', { collapsing, 'has-panes': hasPanes }, { 'transparent-mode': transparentMode }, className), activeIndex: finalActiveTabIndex, onTabChange: defaultOnTabChange, panes: panes, menu: menu, children: children })] }));
};
Tab.propTypes = {
    elmId: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    role: PropTypes.oneOf(['primary', 'secondary', undefined]),
    collapsing: PropTypes.bool,
    menu: PropTypes.object,
    panes: PropTypes.array,
    onTabChange: PropTypes.func,
    activeIndex: PropTypes.number,
    customCollapseRenderer: PropTypes.func,
    transparentMode: PropTypes.bool,
};
Tab.Pane = SemanticTab.Pane;
export default Tab;
//# sourceMappingURL=index.js.map